
import { CommonGet, CommonPost } from '../../../utils/CommonFetch';
import tokenDecoder from '../../../components/Common/tokenDecoder';

export default{

    getGroups,
    getOperationEntityConfiguration,
    getOperationalEntityByGroupEntityID,
    saveOperationEntityConfiguration,
    editData,
    GetCollectionPointsFilter,
    GetAllCollectionPoints,
    getConfigurationNames,
    GetMultipleCollectionPoints,
    getCollectionPointsByOperationentityGroupID
    

};

async function getGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getOperationalEntityByGroupEntityID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + groupID)
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return array;
}

async function getOperationEntityConfiguration(groupID, operationEntityID, collectionPointID){
    var response = await CommonGet('/api/OperationEntityConfiguration/GetOperationEntityConfiguration', 'groupID=' + groupID + '&operationEntityID=' + operationEntityID + '&collectionPointID=' + collectionPointID );

    return response.data; 
    
}

async function getCollectionPointsByOperationentityGroupID(operationEntityID, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if(item[1]["operationEntityID"] === parseInt(operationEntityID) && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
                collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function saveOperationEntityConfiguration(data) {
 
    var dataModel = {
       groupID: parseInt(data.groupID),
       operationEntityID: parseInt(data.operationEntityID),
       collectionPointID: parseInt(data.collectionPointID),
       collectionPointList: data.collectionPointList,
       configurationName: data.configurationName,
       configurationType: parseInt(data.configurationTypeID),
       configurationValue: parseInt(data.configurationValue),
       measuringUnit: parseInt(data.measuringUnit),
       minValue: parseInt(data.minValue),
       maxValue: parseInt(data.maxValue),
       isApply: data.isApply,
       isActive: data.isActive,
       JsonString: data.JsonString
     }
    

   var result = await CommonPost('/api/OperationEntityConfiguration/SaveOperationEntityConfiguration',null, dataModel);

   

   return result;


}
async function editData(data) {
 
    var dataModel = {
       groupID: parseInt(data.groupID),
       operationEntityID: parseInt(data.operationEntityID),
       collectionPointID: parseInt(data.collectionPointID),
       collectionPointList: data.collectionPointList,
       configurationName: data.configurationName,
       configurationType: parseInt(data.configurationTypeID),
       configurationValue: parseInt(data.configurationValue),
       measuringUnit: parseInt(data.measuringUnit),
       configID: parseInt(data.configID),
       mapID: parseInt(data.mapID),
       minValue: parseInt(data.minValue),
       maxValue: parseInt(data.maxValue),
       isApply: data.isApply,
       isActive: data.isActive,
       JsonString: data.JsonString
     }

   var result = await CommonPost('/api/OperationEntityConfiguration/UpdateOperationEntityConfiguration',null, dataModel);
   return result;

}

async function GetCollectionPointsFilter(id) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/Card/GetCollectionPointsFilter', null);
    for (let item of Object.entries(response.data)) {
        if (item[1] !== undefined && item[1]["operationEntityID"] === parseInt(id) )
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }
    return collectionPointArray;
}

async function GetAllCollectionPoints(id, collectionPointID) {
    const response = await CommonGet('/api/CollectionPoint/GetCollectionPointsForOperationcard', 'operationEntityID=' + id + '&collectionPointID=' + collectionPointID);
    
    return response.data;
}

async function getConfigurationNames(operationEntityID) {

    let response = await CommonGet('/api/OperationEntityConfiguration/GetConfigurationNames', 'operationEntityID=' + operationEntityID);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
      groupArray[item[1]["id"]] = item[1]["configurationName"]
        
    }
    return groupArray;
}

async function GetMultipleCollectionPoints(operationEntityID, configurationName) {
    const response = await CommonGet('/api/OperationEntityConfiguration/GetCollectionPointByConfigurationNameOperationEntityID', 'operationEntityID=' + operationEntityID + '&configurationName=' + configurationName);
    return response.data;
}
